module.exports = __webpack_public_path__ + "img/16.18819a27.jpg";